// src/api/encounterApi.ts

import { createAsyncThunk } from "@reduxjs/toolkit"
import { serverApi, getAuthHeaders, handleApiResponse, handleReferenceResponse, queApi } from "@core/api/core"
import { PharmaItemSerializer as PharmaComplexSerializer } from "@/types/pharma"
import { CommonReferenceResponse } from "@/types/common"

export const fetchPharmaComplex = createAsyncThunk<PharmaComplexSerializer[], void, { rejectValue: string }>(
  "pharma/fetchPharmaComplex",
  async (_, { rejectWithValue }) => {
    try {
      const requestUrl = `/reference/pharma_complex/`
      const response = await queApi.get<CommonReferenceResponse>(requestUrl)

      const data = handleReferenceResponse(response)

      if (!data.columns) {
        throw new Error("columns is undefined in pharma items response")
      }

      if (!data.results) {
        throw new Error("result is undefined in pharma items response")
      }

      const pharmaComplexes: PharmaComplexSerializer[] = (data.results as any[][]).map((row: any[]) => {
        // columns[i] ↔ row[i] 매핑
        const obj = Object.fromEntries(data.columns.map((col, i) => [col, row[i]])) as Record<string, any>

        return {
          id: Number(obj["id"]) || 0,
          hiraPharmaId: String(obj["hiraPharmaId"] || obj["hira_pharma_id"] || ""),
          pharmaProductCode: String(obj["pharmaProductCode"] || ""),
          pharmaProductName: String(obj["pharmaProductName"] || ""),
          pharmaCompany: String(obj["pharmaCompany"] || ""),
          pharmaMaxPrice: Number(obj["pharmaMaxPrice"]) || 0,
          pharmaGrossWeight: Number(obj["pharmaGrossWeight"]) || 0,
        }
      })
      return pharmaComplexes
    } catch (error: any) {
      return rejectWithValue(error.message || "약품 정보 조회 중 오류가 발생했습니다.")
    }
  }
)
